import React from 'react';
import { ToastContainer as ToastifyContainer, ToastContainerProps } from 'react-toastify';
import { useMatchMedia } from '@guildeducationinc/catalog-tools';
import { FastSlide } from 'src/components/Toast/transitions';

export const ToastContainer: React.FC<ToastContainerProps> = props => {
	// 480px is where toastify will move to their mobile/full width style. We use this breakpoint to switch
	// the position of the toast so it will slide up on mobile instead of sliding in from the left.
	const isMobile = useMatchMedia('(max-width: 480px)');

	return (
		<ToastifyContainer
			className='toast-container'
			closeButton={false}
			closeOnClick={false}
			hideProgressBar
			position={isMobile ? 'bottom-center' : 'bottom-right'}
			transition={FastSlide}
			{...props}
		/>
	);
};
